import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import { breakpointFrom } from 'utils/breakpoints'

type StyleProps = {
  badge: string
}

const StyledContainer = styled(motion.div)<StyleProps>`
  position: fixed;
  bottom: ${({ theme }) => theme.space[1]};
  right: ${({ theme }) => theme.space[1]};
  z-index: 3;
  width: 166px;
  height: 166px;
  background: ${({ badge }) => `url(${badge})`};
  background-size: cover;
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  ${({ theme }) => breakpointFrom(theme.breakpoints.lg)} {
    width: 238px;
    height: 238px;
    bottom: ${({ theme }) => theme.space[3]};
    right: ${({ theme }) => theme.space[3]};
  }

  ${({ theme }) => breakpointFrom(theme.breakpoints.xl)} {
    width: 250px;
    height: 250px;
  }
`

const StyledTitle = styled.h3`
  ${({ theme }) => theme.typography.SmH3};
  margin-bottom: ${({ theme }) => theme.space[0]};
  font-size: 1.2rem;

  ${({ theme }) => breakpointFrom(theme.breakpoints.lg)} {
    ${({ theme }) => theme.typography.LrgH3};
    font-size: 1.8rem;
  }

  ${({ theme }) => breakpointFrom(theme.breakpoints.xl)} {
    ${({ theme }) => theme.typography.XLH3};
    font-size: 2rem;
  }
`

const StyledCodeText = styled.p`
  ${({ theme }) => theme.typography.SmBody3};
  font-weight: 800;
  opacity: 0.76;

  ${({ theme }) => breakpointFrom(theme.breakpoints.lg)} {
    ${({ theme }) => theme.typography.LrgH4};
  }

  ${({ theme }) => breakpointFrom(theme.breakpoints.xl)} {
    ${({ theme }) => theme.typography.XLH4};
  }
`

const StyledCloseButton = styled.button`
  ${({ theme }) => theme.typography.SmBody3};
  opacity: 0.76;
  color: ${({ theme }) => theme.colors.white};
  background: none;
  border: none;
  text-decoration: underline;
  cursor: pointer;
  margin-top: ${({ theme }) => theme.space[0.5]};

  ${({ theme }) => breakpointFrom(theme.breakpoints.lg)} {
    margin-top: ${({ theme }) => theme.space[1]};
    ${({ theme }) => theme.typography.LrgBody3};
  }
`

type Props = StyleProps & {
  title: string
  codeText: string
  onCloseButtonClick: () => void
}

export const PromoBadge = ({
  badge,
  title,
  codeText,
  onCloseButtonClick,
}: Props) => {
  return (
    <StyledContainer
      badge={badge}
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      exit={{ scale: 0 }}
      transition={{ duration: 0.5 }}
    >
      <StyledTitle>{title}</StyledTitle>
      <StyledCodeText>{codeText}</StyledCodeText>
      <StyledCloseButton
        aria-label="Close promo badge"
        onClick={onCloseButtonClick}
      >
        Close
      </StyledCloseButton>
    </StyledContainer>
  )
}
